//initial redux
import { DateTime, persist } from "../utils";

const initialState = {
	timeRange: {
		startDate: DateTime.add("day", DateTime.startOf("day"), -7),
		endDate: DateTime.endOf("day"),
		key: "selection"
	}
};

const persistConf = {
	whitelist: ["timeRange"]
};

/////////
//types
export const types = {
	UPDATE_TIME_RANGE: "redux/time/UPDATE_TIME_RANGE"
};

///////////
//reducers
const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.UPDATE_TIME_RANGE:
				return { ...state, isBusy: true, timeRange: action.payload.timeRange };

			default:
				return state;
		}
	}
};
export const reducer = persist("time", reducers.reducer, persistConf);

//////////
//sagas
export const sagas = {
	*rootSaga() {}
};

////////
//actions
export const actions = {
	updateTimeRange(timeRange) {
		return {
			type: types.UPDATE_TIME_RANGE,
			payload: { timeRange }
		};
	}
};



// WEBPACK FOOTER //
// ./src/redux/timeRedux.js